import { RootState } from '../store';
export const filterSelector = (state: RootState) => state.filter;
